<template>
    <DForm @submit.prevent="submitForm">
        <DCard
            :title="__('settings.vm_monitoring.name')"
            :padding="true"
            class="mb-4"
        >
            <DFormRow
                :label="__('settings.vm_monitoring.form.base_url')"
                :hint="__('settings.vm_monitoring.form.base_url_hint')"
                :error="errors.base_url"
            >
                <DInput
                    id="vm_monitoring_base_url"
                    v-model="form.base_url"
                    :placeholder="__('settings.vm_monitoring.form.base_url')"
                    :is-valid="isFormFieldValid('base_url')"
                    type="text"
                />
            </DFormRow>
        </DCard>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    vmMonitoringSetting: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    base_url: props.vmMonitoringSetting?.base_url ?? ''
})

const submitForm = () => {
    emit('form-submitted', form)
}
</script>
